import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { Router } from '@angular/router';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { TranslocoService } from '@ngneat/transloco';
import { ROWS_PER_PAGE } from '../shared/constants';

export class BaseList {

  public loading = false;
  public messages: Array<any> = [];
  protected apiUrl: string = null;
  protected rightLoad: string = null;
  protected rightNew: string = null;
  protected rightOpen: string = null;
  public rowsPerPage = ROWS_PER_PAGE;

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService
  ) { }

  loadList(): void {}

  onReload(): void {
    if (this.rightLoad === null || this.auth.hasRight(this.rightLoad)) {
      this.loadList();
    }
  }

  onNew(): void {
    if (this.rightNew === null || this.auth.hasRight(this.rightNew)) {
      this.router.navigate([this.apiUrl + '/new']);
    }
  }

  onOpen(value: any): void {
    if (this.rightOpen === null || this.auth.hasRight(this.rightOpen)) {
      this.router.navigate([this.apiUrl, value.id]);
    }
  }

}
